
import { SET_BANNER, SET_MODAL, UPDATE_MODAL } from './mutation-types'

export default {
	[SET_BANNER] (state, banner) {
		state.banner = { ...banner }
	},

	[SET_MODAL] (state, modalOptions) {
		state.modal = modalOptions
	},

	[UPDATE_MODAL] (state, modalOptions) {
		state.modal = { ...state.modal, ...modalOptions }
	}
}
